module.exports = __webpack_public_path__ + "static/media/adey-bennett-photo-1.9cd3b8e8.jpg";